export default __webpack_public_path__ + "static/media/Sorocaba.020c496a.png";